import { Button, Col, Form, Input, Modal, notification, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { ReactComponent as EditIcon } from "../../../../assets/logos/edit_icon.svg";
import { ReactComponent as UpdateIcon } from "../../../../assets/logos/update_icon.svg";
import { ReactComponent as AddIcon } from "../../../../assets/logos/add_icon.svg";
import { DataListTable } from "./DistrictList";
import { useLazyListProvinceQuery } from "../../province/redux/provinceApi";
import { useAddDistrictMutation, useEditDistrictMutation } from "../redux/districtApi";
import { useAppSelector } from "../../../../redux/Hooks";

interface AddDistrictProps {
    visible: boolean;
    onCancel: () => void;
    currentDistrict: DataListTable | undefined;
    onAddSuccessful: () => void;
    canEdit: boolean;
}

const AddDistrictModal = ({ visible, onCancel, currentDistrict, onAddSuccessful, canEdit }: AddDistrictProps) => {
    const [form] = Form.useForm();
    const [editing, setEditing] = useState(false);
    const [loadingBtnSubmit, setLoadingBtnSubmit] = useState<boolean>(false);
    const [checkProvince, setCheckProvince] = useState<boolean>(false)

    const [addTrigger] = useAddDistrictMutation();
    const [editTrigger] = useEditDistrictMutation();
    const [triggerProvince, responseProvince] = useLazyListProvinceQuery();

    useEffect(() => {
        triggerProvince({});
    }, [triggerProvince]);

    useEffect(() => {
        if (currentDistrict) {
            form.setFieldsValue({
                districtCode: currentDistrict.districtCode || "",
                districtName: currentDistrict.districtName || "",
                status: currentDistrict.status !== undefined ? currentDistrict.status : undefined,
            })
        }
        else {
            form.setFieldsValue({
                status: 0,
            })
        }
    }, [currentDistrict, form]);

    useEffect(() => {
        if (currentDistrict && responseProvince?.data?.filter((item) => item.status === 0)?.some((item) => item.id === currentDistrict?.provinceId)) {
            form.setFieldsValue({ provinceId: currentDistrict?.provinceId })
        } else {
            form.setFieldsValue({ provinceId: currentDistrict?.provinceName });
            setCheckProvince(true);
        }
    }, [currentDistrict, form, responseProvince?.data]);

    const onFinish = (values: any) => {
        if (!loadingBtnSubmit) {
            setLoadingBtnSubmit(true);
            if (currentDistrict) {
                let provinceId = checkProvince ? currentDistrict.provinceId : values.provinceId;
                editTrigger({
                    id: currentDistrict.key,
                    districtCode: values.districtCode?.trim() || "",
                    districtName: values.districtName?.trim() || "",
                    provinceId,
                    status: values.status,
                }).unwrap()
                    .then((res: any) => {
                        notification.success({
                            message: 'Cập nhật Quận/Huyện thành công.'
                        });
                        setLoadingBtnSubmit(false);
                        onAddSuccessful();
                    }
                    ).catch((err: any) => {
                        notification.error({
                            message: err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!"
                        });
                        setLoadingBtnSubmit(false);
                    })
            }
            else {
                addTrigger({
                    districtCode: values.districtCode?.trim() || "",
                    districtName: values.districtName?.trim() || "",
                    provinceId: values.provinceId?.trim() || "",
                    status: values.status,
                }).unwrap()
                    .then((res: any) => {
                        notification.success({
                            message: 'Thêm mới Quận/Huyện thành công.'
                        })
                        setLoadingBtnSubmit(false);
                        onAddSuccessful();
                    }
                    ).catch((err: any) => {
                        notification.error({
                            message: err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!"
                        });
                        setLoadingBtnSubmit(false);
                    })
            }
        }
    };


    return (
        <>
            <Modal
                style={{ borderRadius: "8px", overflow: "hidden", minWidth: "360px" }}
                onCancel={onCancel}
                visible={visible}
                footer={false}
                title={currentDistrict ? "Thông tin Quận/Huyện" : "Thêm mới Quận/Huyện"}
                width={"40%"}
            >
                <Form
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    labelAlign="left"
                    form={form}
                    onFinish={onFinish}
                >
                    <Row gutter={20}>
                        <Col span={24} xs={24} xl={24} xxl={24}>
                            <Form.Item
                                label="Mã Quận/Huyện"
                                name="districtCode"
                                rules={[
                                    { required: true, message: "Vui lòng nhập Mã Quận/Huyện." },
                                    {
                                        pattern: /^[^\sÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]+$/,
                                        message: 'Mã Quận/Huyện không chứa dấu cách và ký tự có dấu.',
                                    }
                                ]}
                            >
                                <Input
                                    className="propNameInput"
                                    placeholder="Nhập mã Quận/Huyện "
                                    allowClear
                                    disabled={!editing && currentDistrict ? true : false}
                                    maxLength={10}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24} xs={24} xl={24} xxl={24}>
                            <Form.Item
                                label="Tên Quận/Huyện"
                                name="districtName"
                                rules={[
                                    { required: true, whitespace: true, message: "Vui lòng nhập Tên Quận/Huyện." },
                                ]}
                            >
                                <Input
                                    className="propNameInput"
                                    placeholder="Nhập tên Quận/Huyện"
                                    allowClear
                                    maxLength={50}
                                    disabled={!editing && currentDistrict ? true : false}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24} xs={24}>
                            <Form.Item
                                label="Tỉnh/Thành phố"
                                name="provinceId"
                                rules={[
                                    { required: true, message: "Vui lòng chọn Tỉnh/Thành phố." }
                                ]}
                            >
                                <Select
                                    placeholder="Chọn Tỉnh/Thành phố"
                                    showSearch
                                    allowClear
                                    listHeight={130}
                                    optionFilterProp="label"
                                    disabled={!editing && currentDistrict ? true : false}
                                    filterSort={(optionA, optionB) =>
                                        optionA?.label?.toLowerCase().localeCompare(optionB?.label?.toLowerCase())
                                    }
                                    options={responseProvince?.data?.filter((item) => item.isDelete === 0 && item.status === 0)?.map(item => ({
                                        label: item.provinceName,
                                        value: item.id,
                                    }))}
                                    onChange={() => { setCheckProvince(false) }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24} xs={24} xl={24} xxl={24}>
                            <Form.Item
                                label="Trạng thái"
                                name="status"
                                rules={[
                                    { required: true, message: "Vui lòng chọn Trạng thái." }
                                ]}
                            >
                                <Select
                                    optionFilterProp="label"
                                    allowClear
                                    placeholder="--Lựa chọn--"
                                    disabled={!editing && currentDistrict ? true : false}
                                >
                                    <Select.Option value={0}>Hoạt động</Select.Option>
                                    <Select.Option value={1}>Không hoạt động</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>


                    {(!editing && currentDistrict) && (
                        <div className="modal-action-buttons" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {canEdit ?
                                <Button
                                    key="update"
                                    style={{ height: "36px", width: "36px", padding: 0 }}
                                    onClick={() => {
                                        setEditing(!editing);
                                    }}
                                >
                                    <EditIcon />
                                </Button> : <></>
                            }
                            <Button key="close" style={{ height: "36px", width: "120px" }} onClick={onCancel}>
                                Đóng
                            </Button>
                        </div>
                    )}


                    {editing && (
                        <div className="modal-action-buttons" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button key="edit" style={{ height: "36px", width: "120px", marginRight: 10 }} onClick={onCancel}>
                                Đóng
                            </Button>
                            <Button key="back" type="primary" style={{ height: "36px", width: "120p", display: "flex", alignItems: "center" }} htmlType="submit">
                                <UpdateIcon style={{ marginRight: 4 }} />
                                Cập nhật
                            </Button>
                        </div>
                    )}

                    {!currentDistrict && (
                        <div className="modal-action-buttons" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button key="update" style={{ height: "36px", width: "120px", marginRight: 10 }} onClick={onCancel}>
                                Đóng
                            </Button>
                            <Button key="back" type="primary" style={{ height: "36px", width: "120px", display: "flex", alignItems: "center" }} htmlType="submit">
                                <AddIcon style={{ marginRight: 4 }} />
                                Thêm mới
                            </Button>
                        </div>
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default AddDistrictModal;
